import { combineReducers } from 'redux';

import { infosReducer } from './infos/infos.reducer';
import type { StaticFormState } from './staticForm.model';
export const staticFormReducer = combineReducers<StaticFormState>({
  infos: infosReducer,
});
